var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"bg-blue-100 h-screen w-screen overflow-hidden flex"},[_c('div',{staticClass:"flex-grow"},[_c('preview')],1),_c('sidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }